<template>
  <div class="order-list">
    <KitchenOrderCardCompent
      v-for="orderData in orderList"
      :key="orderData.orderId"
      :order-data="orderData"
      @serve-dish="handleServeDish"
      @complete-all="handleCompleteAll"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import KitchenOrderCardCompent from './KitchenOrderCardCompent.vue';
  import { OrderDataModel } from '../model/kitchen';

  interface Props {
    orderList: Array<OrderDataModel>;
  }
  const props = defineProps<Props>();

  const orderList = ref<Array<OrderDataModel>>(props.orderList);

  const handleServeDish = (dishId: string) => {
    // 实现出餐逻辑
    console.log(`出餐菜品ID: ${dishId}`);
  };

  const handleCompleteAll = (orderId: string) => {
    // 实现全部完成逻辑
    console.log(`完成订单ID: ${orderId}`);
  };
</script>

<style scoped lang="less">
  .order-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  :deep(.KitchenOrderCardCompent) {
    flex: 0 0 calc(33.33% - 8px);
    max-width: calc(33.33% - 8px);
  }
</style>
